module.exports = {
  DEMO_TYPES: ["answerinput", "coding", "library", "imports", "hvu"],

  QUESTION_TYPES: {
    answerinput: 1,
    coding: 2
  },

  LIBRARY_TYPES: {
    circuits: 2,
    matlab: 3
  }
};
